module.exports = ".parametri-generali-box{\n\tpadding-top: 15px;\n\tpadding-bottom: 15px;\n}\n"